import { render, staticRenderFns } from "./vHtml.vue?vue&type=template&id=4c745971&"
import script from "./vHtml.vue?vue&type=script&lang=js&"
export * from "./vHtml.vue?vue&type=script&lang=js&"
import style0 from "./vHtml.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports